import { ReducerFunctions } from "../../config/helper";
import {
  CustomerShipmentsList,
  CustomerPaymentTerms,
  CustomerShipmentTerms,
  CustomerShipmentDoc,
  CustomerBillingDoc,
  CustomerBillingList,
  CustomerShipmentTrack,
  SyncCustomerOrders,
  SyncCustomerDetails,
  CustomerShipmentDetails,
  Claims,
  SubmitClaims,
  CreditNotes,
  ClaimDetails,
  DownloadDocClaimList,
  DocClaimsList,
  ShipmentHistory,
  CustomerOnWaterReport,
  CustomerInvReport,
} from "./Action";

export const customer_shipments_list_reducer = (state = {}, action) => {
  let data = Array.isArray(action?.payload)
    ? [...action?.payload]
    : typeof action?.payload === "string"
    ? action?.payload
    : { ...action?.payload };
  switch (action?.type) {
    case CustomerShipmentsList.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CustomerShipmentsList.SUCCESS: {
      let arr = [];
      data?.forEach((element) => {
        let idx = arr.findIndex(
          (ele) => ele.ShipNo === element.ShipNo && ele.ShipNo !== ""
        );
        if (idx > -1) {
          arr[idx].do_numbers.push(element.DeliveryNo);
          arr[idx].ZfillTot =
            parseFloat(arr[idx].ZfillTot) + parseFloat(element.ZfillTot);
          arr[idx].DeliveredQty =
            parseInt(arr[idx].DeliveredQty) + parseInt(element.DeliveredQty);
          arr[idx].Kwmeng =
            parseInt(arr[idx].Kwmeng) + parseInt(element.Kwmeng);
        } else {
          arr.push({ ...element, do_numbers: [element.DeliveryNo] });
        }
      });
      return {
        ...state,
        data: arr,
        loading: false,
        success: true,
      };
    }
    case CustomerShipmentsList.FAILED:
      return {
        ...state,
        data,
        loading: false,
        success: false,
      };
    case CustomerShipmentsList.RESET:
      return {
        loading: false,
      };

    default:
      return state;
  }
};

export const get_claims_reducer = ReducerFunctions(Claims, {});

export const get_claim_doc_reducer = ReducerFunctions(DownloadDocClaimList, {});

export const shipment_history_reducer = ReducerFunctions(ShipmentHistory, {});

export const get_claim_docs_list_reducer = ReducerFunctions(DocClaimsList, {});

export const get_claim_reducer = ReducerFunctions(ClaimDetails, {});

export const credit_notes_reducer = ReducerFunctions(CreditNotes, {});

export const submit_claims_reducer = ReducerFunctions(SubmitClaims, {});
export const customer_payment_terms_reducer = ReducerFunctions(
  CustomerPaymentTerms,
  {}
);
export const customer_shipment_terms_reducer = ReducerFunctions(
  CustomerShipmentTerms,
  {}
);
export const customer_shipment_doc_reducer = ReducerFunctions(
  CustomerShipmentDoc,
  {}
);
export const customer_billing_doc_reducer = ReducerFunctions(
  CustomerBillingDoc,
  {}
);
export const customer_billing_list_reducer = ReducerFunctions(
  CustomerBillingList,
  {}
);
export const customer_shipment_track_reducer = ReducerFunctions(
  CustomerShipmentTrack,
  {}
);

export const customer_shipment_details_reducer = ReducerFunctions(
  CustomerShipmentDetails,
  { loading: true }
);
export const customer_on_water_shipment_reducer = ReducerFunctions(
  CustomerOnWaterReport,
  {}
);

export const customer_get_inv_rep_reducer = ReducerFunctions(
  CustomerInvReport,
  {}
);

export const sync_customer_orders_reducer = ReducerFunctions(
  SyncCustomerOrders,
  {}
);
export const sync_customer_details_reducer = ReducerFunctions(
  SyncCustomerDetails,
  {}
);
